import { useTranslation } from 'react-i18next'
import { Modal } from '../common/Modal'
import { Button } from '../common/Button'

interface AllNotificationsDisabledModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function AllNotificationsDisabledModal({
  isOpen,
  onClose,
  onConfirm,
}: AllNotificationsDisabledModalProps) {
  const { t } = useTranslation()

  const contentStyles: React.CSSProperties = {
    textAlign: 'center',
    padding: '1rem 0',
  }

  const iconStyles: React.CSSProperties = {
    width: '48px',
    height: '48px',
    margin: '0 auto 1rem',
    color: '#F59E0B',
  }

  const messageStyles: React.CSSProperties = {
    fontSize: '14px',
    color: '#374151',
    marginBottom: '1.5rem',
    lineHeight: 1.6,
  }

  const buttonContainerStyles: React.CSSProperties = {
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'center',
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Warning">
      <div style={contentStyles}>
        <svg
          style={iconStyles}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>

        <p style={messageStyles}>{t('settings.allNotificationsOff')}</p>

        <div style={buttonContainerStyles}>
          <Button variant="outline" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm}>{t('settings.disableAnyway')}</Button>
        </div>
      </div>
    </Modal>
  )
}
